import React, { useEffect, useState } from "react";
import "../../../../../styles/ambassadorChallenge/challengeControls.scss";
import axios from "axios";
import { isAuth } from "../../../../../pages/auth/ProtectedRoute";
import { useAmbassadorChallengeContext } from "../../../../../contexts/AmbassadorChallengeContext";

const ChallengeControls: React.FC = () => {
  const { useRemainingTime } = useAmbassadorChallengeContext();

  const [prizes, setPrizes] = useState<ChallengeControlsData | null>(null);

 
  useEffect(() => {
    const fetchPrizes = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_HOST_API}ambassador/current-challenge-prizes`,
          {
            headers: {
              Authorization: `Bearer ${isAuth()}`,
            },
          }
        );
        setPrizes(res.data.data);
      } catch (err: any) {
        console.log("error fetching prizes data:", err);
      }
    };

    fetchPrizes();
  }, []);

  const formatDate = (timestamp: string | null): string | null => {
    if (!timestamp) return null;

    const date = new Date(timestamp);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
}

   const getRemainingDays = (endTime: string | null): number | null => {
  if (!endTime) return 0;

  const endDate = new Date(endTime.replace(" ", "T")).getTime();
  const now = Date.now();

  if (isNaN(endDate) || endDate <= now) return 0;

  const diffInMs = endDate - now;

  const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  return days;
};


function getTimePercentage(start: string | null, end: string | null): number | null {
  if(!start || !end) return null
  
    const startMs = new Date(start).getTime();
    const endMs = new Date(end).getTime();
    const nowMs = Date.now();

    if (endMs >= nowMs) return 100;

    const total = endMs - startMs;
    const elapsed = nowMs - startMs;

    if (total <= 0) return 0;

    const percentage = (elapsed / total) * 100;

    return Math.min(Math.max(percentage, 0), 100);
}


  return (
    <div className="challenge-card">
      <div className="challenge-header">
        <div className="title-container">
          <div className="title-wrapper">
            <h2 className="challenge-title">{prizes && prizes.title}</h2>
            <span className="challenge-status active">Active</span>
          </div>
          <p className="challenge-date">{formatDate(prizes && prizes.start_date)} – {formatDate(prizes && prizes.end_date)}</p>
        </div>

        {/* <div className="challenge-actions">
          <button className="pause-btn">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M6 19H10V5H6V19ZM14 5V19H18V5H14Z" fill="black" />
            </svg>
            Pause
          </button>
          <button className="pause-btn">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_11272_60615)">
                <path
                  d="M7 4V20L20 12L7 4Z"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_11272_60615">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            Continue
          </button>
          <button className="end-btn">End challenge</button>
        </div> */}
      </div>

      <div className="challenge-progress">
        <div className="progress-labels">
          <span>Challenge progress</span>
          <span className="remaining">{useRemainingTime(prizes && prizes.end_date)} {prizes ? 'remaining' : ''}</span>
        </div>
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${getTimePercentage(prizes && prizes.start_date, prizes && prizes.end_date)}%` }}></div>
        </div>
      </div>

      <div className="challenge-rewards">
        <div className="reward">
          <h4>1st Place</h4>
          <p>${prizes && prizes.first_prize} + Gold badge</p>
        </div>
        <div className="reward">
          <h4>2nd Place</h4>
          <p>${prizes && prizes.second_prize} + Silver badge</p>
        </div>
        <div className="reward">
          <h4>3rd Place</h4>
          <p>${prizes && prizes.third_prize} + Bronze badge</p>
        </div>
      </div>
    </div>
  );
};

export default ChallengeControls;
